import type { FeGridSettings } from '../types/Api';
const DEFAULT_ITEMS_PER_PAGE = 50;
export const DEFAULT_SETTINGS: FeGridSettings = {
  valueWrapMode: 'TRUNCATE',
  horizontalSeparatorsVisible: true,
  itemsPerPage: DEFAULT_ITEMS_PER_PAGE,
  keyboardNavigationEnabled: false,
  columnGroupsVisible: false,
  stripedRows: false,
  summaryRowVisible: false,
  verticalSeparatorsVisible: true,
  headerHeight: 'DEFAULT',
  rowHeight: 'DEFAULT'
};